import { useMutation } from "@apollo/client";
import {
  GetOrderByIdDocument,
  RemoveOrderProductsDocument,
} from "../../gql/generated/graphql";

interface Props {
  orderId: string;
}

export const useRemoveOrderProducts = ({ orderId }: Props) => {
  const [removeOrderProductsMutation, { loading }] = useMutation(
    RemoveOrderProductsDocument,
    {
      refetchQueries: [GetOrderByIdDocument],
      awaitRefetchQueries: true,
    }
  );

  const removeOrderProducts = (productIds: string[]) =>
    removeOrderProductsMutation({
      variables: {
        orderId,
        productIds,
      },
    });

  return {
    removeOrderProducts,
    loading,
  };
};
